module.exports = __webpack_public_path__ + "static/vf_wdress_core.e0e149e7.svg";